import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { AssetManagementControllerFindAllAssetManagementMovementHistory$Params } from 'src/app/api/fn/asset-management/asset-management-controller-find-all-asset-management-movement-history';
import {
  UserItem,
  AssetManagementMovementHistoryItem,
  AssetManagementItem,
} from 'src/app/api/models';
import {
  AssetManagementService,
  GeoService,
  AgreementsService,
  RegistryOfficesService,
  IdentityService,
  ProductService,
} from 'src/app/api/services';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MovementTypeEnum } from '../enums/movement_types_enum.enum';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { BehaviorSubject, debounceTime, distinctUntilChanged, of, switchMap } from 'rxjs';
import { manipulateToUTCISOString } from 'src/main';
import { IdentityControllerGetAll$Params } from 'src/app/api/fn/identity/identity-controller-get-all';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-modal-movement-history',
  templateUrl: './modal-movement-history.component.html',
  styleUrls: ['./modal-movement-history.component.scss'],
})
export class ModalMovementHistoryComponent {
  @ViewChild('dt2') table_movement_history?: Table;

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];
  loading = false;
  asset_movement_history: AssetManagementMovementHistoryItem[] = [];
  totalRecordsMovementsHistory: number = 0;
  selectedAsset?: AssetManagementItem;
  question_title: string;

  autocompleteUsers$ = new BehaviorSubject<string>('');
  suggestedUsers: UserItem[] = [];

  movement_types = [
    { name: MovementTypeEnum.LOAD, value: 'C' },
    { name: MovementTypeEnum.TRANSFER, value: 'T' },
    { name: MovementTypeEnum.ADJUSTMENT, value: 'A' },
    { name: MovementTypeEnum.RETURN, value: 'R' },
  ];

  frmFilterMovementHistory = new FormGroup({
    rangeDates: new FormControl<Date[] | undefined>(undefined),
    movement: new FormControl<string | undefined>(undefined),
    related_user: new FormControl<UserItem | undefined>(undefined),
  });

  constructor(
    public auth: AuthService,
    private assetMgmtService: AssetManagementService,
    private userService: IdentityService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService
  ) {
    this.question_title = config.data!.question_title;
    this.selectedAsset = config.data!.selectedAsset;
  }

  ngOnInit() {
    //attivo autocomplete users
    this.autocompleteUsers$
      .pipe(
        debounceTime(300),

        switchMap(query => {
          if (query) {
            let params: IdentityControllerGetAll$Params = {
              limit: 15,
              skip: 0,
              query: query,
            };
            return this.userService.identityControllerGetAll(params);
          } else {
            return of({
              data: { list: [] },
            });
          }
        })
      )
      .subscribe({
        next: res => {
          this.suggestedUsers = res.data.list.map(u => ({
            ...u,
            fullName: `${u.name} ${u.last_name}`,
          }));
        },
      });

    this.frmFilterMovementHistory.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(v => {
        this.loadAssetMovementHistory(this.table_movement_history?.createLazyLoadMetadata());
      });
  }

  filterUsers(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteUsers$.next(query);
  }

  loadAssetMovementHistory(event: TableLazyLoadEvent) {
    this.loading = true;
    const frmValue = this.frmFilterMovementHistory.value;
    const rangeDateFrom = frmValue.rangeDates
      ? manipulateToUTCISOString(frmValue.rangeDates[0], false)
      : undefined;
    const rangeDateTo = frmValue.rangeDates
      ? manipulateToUTCISOString(frmValue.rangeDates[1], true, true)
      : undefined;
    const params: AssetManagementControllerFindAllAssetManagementMovementHistory$Params = {
      limit: +event.rows!,
      skip: +event.first!,
      operation_type: frmValue.movement || undefined,
      related_user_id: frmValue.related_user ? frmValue.related_user.id : undefined,
      created_on_from: rangeDateFrom,
      created_on_to: rangeDateTo,
      id: this.selectedAsset?.id!,
    };
    this.assetMgmtService
      .assetManagementControllerFindAllAssetManagementMovementHistory(params)
      .subscribe({
        next: res => {
          this.asset_movement_history = res.data.list;
          this.totalRecordsMovementsHistory = res.data.count;
          this.loading = false;
        },
      });
  }

  clearAssetMovementHisotry(table: Table, e: Event) {
    this.frmFilterMovementHistory.reset();
  }
}
